module.exports = __webpack_public_path__ + "img/cwm2018-0037-0058-dm.33a0b002.jpg";